export async function incrementNumberJuzuReads(id) {
  const response = await fetch(`https://api.idrissa-sall.com/kamil/juzu/${id}/increment`)
 
  const data = await response.json();

  return data.numberOfReads;
}